import Model from './model'

class GrowthStore extends Model({
  quiz: undefined,
  questionResponse: undefined,
  finishQuizResult: undefined,
}) {}

export default GrowthStore
